import PcoWorkflowsPage from './pages/PcoWorkflowsPage.vue'

const routes = [
  {
    path: 'ctrl-workflow-recuperacao',
    name: 'ctrl-workflow-recuperacao',
    component: PcoWorkflowsPage
  }
];

export default routes;